export const EASE = [0.215, 0.61, 0.355, 1];

import { motion } from 'framer-motion';

export function Reveal({ children, delay = 0, y = 28, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, sub, dark = false, center = false }) {
  return (
    <div className={`max-w-3xl ${center ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <Reveal>
          <p className={`text-xs font-bold uppercase tracking-[0.22em] ${dark ? 'text-brand-orange' : 'text-brand-orange'}`}>
            {eyebrow}
          </p>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2
          className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.06] mt-3 text-balance ${
            dark ? 'text-white' : 'text-brand-ink'
          }`}
        >
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? 'text-white/70' : 'text-slate-500'}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}

export function MaskedLine({ children, delay = 0, className = '' }) {
  return (
    <span className={`block overflow-hidden pb-1 -mb-1 ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: '112%' }}
        animate={{ y: 0 }}
        transition={{ duration: 0.85, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}
